import { useCallback } from "react";
import { useChosenDepartment } from "../contexts/ChosenDepartment";
import { type ScheduleDayShift, scheduleDayOfShift } from "../utils/departmentWeeks";
import type { NurseInShift } from "../utils/models";

/** The schedule day a shift is listed on, in the chosen department: the provider's `scheduleDayOf` without the provider. */
export const useScheduleDayOf = (): ((shift: Pick<NurseInShift, "startTime" | "shiftType">) => ScheduleDayShift) => {
	const { chosenDepartment } = useChosenDepartment();
	const { dayStart, scheduled_shift_delta_minutes } = chosenDepartment;
	return useCallback((shift) => scheduleDayOfShift(shift, { dayStart, scheduled_shift_delta_minutes }), [dayStart, scheduled_shift_delta_minutes]);
};
